import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-100 dark:bg-gray-900 shadow-sm text-gray-700 body-font" }
const _hoisted_2 = { class: "container mx-auto flex flex-wrap lg:p-5 py-3 flex-col md:flex-row items-center" }
const _hoisted_3 = { class: "lg:visible lg:mx-0 mx-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { class: "flex title-font font-medium items-center text-gray-700 dark:text-gray-100" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lg:ml-3 text-xl text-primary" }, "Dforce"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold pt-1" }, "UI")
], -1)
const _hoisted_5 = { class: "md:ml-auto md:mr-auto flex flex-wrap items-center text-base justify-center" }
const _hoisted_6 = { class: "inline-flex items-center py-1 px-3 rounded text-base lg:mt-4 md:mt-0 gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DarkModeSelector = _resolveComponent("DarkModeSelector")!
  const _component_LanguageSelector = _resolveComponent("LanguageSelector")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "mr-5 cursor-pointer font-bold text-gray-700 hover:text-sky-400 dark:hover:text-sky-400 dark:text-gray-200",
          "exact-active-class": "text-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('projects')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/about",
          class: "mr-5 cursor-pointer font-bold text-gray-700 hover:text-sky-400 dark:hover:text-sky-400 dark:text-gray-200",
          "exact-active-class": "text-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('about-me')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_DarkModeSelector, { size: 15 }),
        _createVNode(_component_LanguageSelector)
      ])
    ])
  ]))
}